import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, timeout } from 'rxjs/operators';
import { LanguageModel } from '../../_interfaces';
import XMLString from '../../_utilities/xmlstring';
import { Observable } from 'rxjs';

@Injectable()
export class TranslationService {

    private _url: string = '/svc/grapple/translate';
    private _desturl: string = '/svc/grapple/translate?src=';

    constructor(private _http: HttpClient) {
    }


    public translate (content: any, srcLanguage: string, destLanguage: string, requestFullTranslate: boolean = false): Promise<any> {
        let postBody: string = this.createPostBody(content, srcLanguage, destLanguage, requestFullTranslate);

        return this._http.post(this._url, postBody).pipe(timeout(90000)).toPromise();
    }

    public getSupportedLanguages (): Observable<LanguageModel[]> {
      return this._http.get(this._url).pipe(
        catchError((err: any) => {
          return [];
        }),
        map((resp) => {
          return resp['TranslationLanguagesResponse'] && resp['TranslationLanguagesResponse']['Language'] ? resp['TranslationLanguagesResponse']['Language'] : [];
        })
      );
    }

    public getDestinationLanguages (srcLanguage: string): Observable<LanguageModel[]> {
      return this._http.get(this._desturl.concat(srcLanguage)).pipe(
        catchError((err: any) => {
          return [];
        }),
        map((resp) => {
          return resp['TranslationLanguagesResponse'] && resp['TranslationLanguagesResponse']['Language'] ? resp['TranslationLanguagesResponse']['Language'] : [];
        })
      );
    }
public createPostBody(contentObj: any, srcLanguage: string, destLanguage: string, requestFullTranslate: boolean = false): string {
    let postBody = '<TranslationRequest>';
    postBody += XMLString.xmlwrap(contentObj.title, 'title', false);
    // Add body (summary content) if present.
    const summaryBody = this.ensureSummaryPrefix(this.extractSummaryBody(contentObj.abstract));
    if (summaryBody) {
      postBody += XMLString.xmlwrap(summaryBody, 'abstract', false);
    }

    // Always add main content (even if empty for images)
    postBody += XMLString.xmlwrap(contentObj.text, 'content', false);

    postBody += XMLString.xmlwrap(srcLanguage, 'srcLanguage', false);
    postBody += XMLString.xmlwrap(destLanguage, 'destLanguage', false);
    postBody += XMLString.xmlwrap(requestFullTranslate ? 'true' : 'false', 'restOfDoc', true);
    postBody += '</TranslationRequest>';

    return postBody;
  }

  private extractSummaryBody(summaryHtml: string): string {
    if (!summaryHtml) {
      return '';
    }

    const bodyMatch = summaryHtml.match(/<body[^>]*>([\s\S]*?)<\/body>/i);

    if (bodyMatch && bodyMatch[1]) {
      return bodyMatch[1].trim();
    }

    return summaryHtml.trim();
  }

  private ensureSummaryPrefix(summaryText: string): string {
    if (!summaryText) {
      return '';
    }

    // Strip any existing "Summary:" prefix — send only the body to the backend
    // so it doesn't translate the label into unpredictable variants
    return summaryText.trim().replace(/^summary\s*:\s*/i, '').trim();
  }
}
